(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["silveradda-offer-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('silveradda-offer')) {
    class SilveraddaOffer extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-copy-offer]');
        if (!button || button.dataset.ready === 'true') return;
        button.dataset.ready = 'true';
        button.addEventListener('click', async () => {
          const code = this.dataset.code;
          if (!code) return;
          try {
            await navigator.clipboard.writeText(code);
          } catch (error) {
            const field = document.createElement('textarea');
            field.value = code;
            field.setAttribute('readonly', '');
            field.style.position = 'fixed';
            field.style.opacity = '0';
            document.body.appendChild(field);
            field.select();
            document.execCommand('copy');
            field.remove();
          }
          button.textContent = button.dataset.copiedLabel;
          window.setTimeout(() => {
            button.textContent = button.dataset.defaultLabel;
          }, 1800);
        });
      }
    }
    customElements.define('silveradda-offer', SilveraddaOffer);
  }
  } catch(e) { console.error(e); }
})();

})();
